import React, { useState } from 'react'
import ChatInterface from './components/ChatInterface'
import PipelineStreamer from './components/PipelineStreamer'
import AppRenderer from './components/AppRenderer'
import Header from './components/Header'
import { motion, AnimatePresence } from 'framer-motion'

function App() {
    const [currentStep, setCurrentStep] = useState('chat') // chat, pipeline, render
    const [chatPlan, setChatPlan] = useState(null)
    const [pipelineSession, setPipelineSession] = useState(null)
    const [generatedApp, setGeneratedApp] = useState(null)

    const handleChatComplete = (enhancedPlan) => {
        setChatPlan(enhancedPlan)
        setCurrentStep('pipeline')
    }

    const handlePipelineComplete = (appData) => {
        setGeneratedApp(appData)
        setCurrentStep('render')
    }

    const handleBackToChat = () => {
        setChatPlan(null)
        setPipelineSession(null)
        setGeneratedApp(null)
        setCurrentStep('chat')
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50">
            <Header />

            <main className="container mx-auto px-4 py-8">
                <AnimatePresence mode="wait">
                    {currentStep === 'chat' && (
                        <motion.div
                            key="chat"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.5 }}
                        >
                            <ChatInterface onPlanComplete={handleChatComplete} />
                        </motion.div>
                    )}

                    {currentStep === 'pipeline' && (
                        <motion.div
                            key="pipeline"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.5 }}
                        >
                            <PipelineStreamer
                                chatPlan={chatPlan}
                                onComplete={handlePipelineComplete}
                                onBack={handleBackToChat}
                            />
                        </motion.div>
                    )}

                    {currentStep === 'render' && (
                        <motion.div
                            key="render"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: -20 }}
                            transition={{ duration: 0.5 }}
                        >
                            <AppRenderer
                                appData={generatedApp}
                                onBack={handleBackToChat}
                                onEdit={() => setCurrentStep('chat')}
                            />
                        </motion.div>
                    )}
                </AnimatePresence>
            </main>
        </div>
    )
}

export default App